const eventList = [
  {
    id: 1,
    title: "1 Takar Khabar",
    date: "10",
    month: "Octobar",
  },
  {
    id: 2,
    title: "TCB 10 Taka Kg Chal",
    date: "15",
    month: "Octobar",
  },
  {
    id: 3,
    title: "Walk for Homeless",
    date: "20",
    month: "Octobar",
  },
  {
    id: 4,
    title: "Neighborhood Love",
    date: "2",
    month: "November",
  },
  {
    id: 5,
    title: "Lots of Dreams of Lost Dreams",
    date: "8",
    month: "November",
  },
  {
    id: 6,
    title: "Heart & Sole Fundraiser Walk",
    date: "9",
    month: "November",
  },
  {
    id: 7,
    title: "Inspiration For The World",
    date: "20",
    month: "November",
  },
  {
    id: 8,
    title: "Meat Shots for Hungry",
    date: "2",
    month: "December",
  },
];

export default eventList;
